module.exports = __webpack_public_path__ + "static/media/app-store-download.db31d2ab.svg";